import { configureStore } from "@reduxjs/toolkit";
import authSlice from "../features/user/authSlice";

import watchlistSlice from "../features/watchlists/watchlistSlice";
import notificationSlice from "../features/notifications/notificationSlice";
import ticketSlice from "../features/tickets/ticketSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    watchlists: watchlistSlice,
    notifications: notificationSlice,
    tickets: ticketSlice,
  },
});
